import React from 'react'
import styles from '../ReportTabs/reportTabs.module.scss'
import { Flex, Typography } from 'antd'

const CardChip = ({ label, value, className="", onClick=() =>{} }) => {
    return (
        <div className={`${styles.cardchip} ${className}`} onClick={onClick}>
            <Flex vertical>
                <Typography.Text className='report-label-text'>{label}</Typography.Text>
                <Typography.Title level={3} className={styles.reportNumber}>{value}</Typography.Title>
            </Flex>
        </div>
    )
}

export default CardChip